var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.createAllowed),expression:"!createAllowed"}],staticClass:"expire-message"},[_c('div',{staticClass:"expire-message-content"},[_vm._v(" Срок сдачи отчетности истек. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }